import {
  MlsListingContactFragment,
  MlsListingOfficeFragment,
  MlsListingPropertyFragment,
} from '@client/graphql/__generated__/types';
import { FieldMap } from './mls-info.types';

const PropertyFieldMap: FieldMap<MlsListingPropertyFragment> = {
  type: { label: 'Type' },
  subType: {
    label: 'Sub Type',
    formatter: (value, p) => p.subTypeText ?? value,
  },
  style: { label: 'Style' },
  area: { label: 'Area (sqft)' },
  areaSource: { label: 'Area Source' },
  bedrooms: { label: 'Bedrooms' },
  bathrooms: { label: 'Bathrooms' },
  bathsFull: { label: 'Full Baths' },
  bathsHalf: { label: 'Half Baths' },
  bathsThreeQuarter: { label: '3/4 Baths' },
  yearBuilt: { label: 'Year Built' },
  stories: { label: 'Stories' },
  fireplaces: { label: 'Fireplaces' },
  lotSize: { label: 'Lot Size' },
  lotSizeArea: { label: 'Lot Size Area' },
  lotSizeAreaUnits: { label: 'Lot Size Area Units' },
  lotDescription: { label: 'Lot Description' },
  acres: { label: 'Acres' },
  cooling: { label: 'Cooling' },
  heating: { label: 'Heating' },
  flooring: { label: 'Flooring' },
  roof: { label: 'Roof' },
  construction: { label: 'Construction' },
  foundation: { label: 'Foundation' },
  garageSpaces: { label: 'Garage Spaces' },
  poolFeatures: { label: 'Pool Features' },
  laundryFeatures: { label: 'Laundry Features' },
  interiorFeatures: { label: 'Interior Features' },
  exteriorFeatures: { label: 'Exterior Features' },
  water: { label: 'Water Source' },
  view: { label: 'View' },
  accessibility: { label: 'Accessibility' },
  additionalRooms: { label: 'Additional Rooms' },
  maintenanceExpense: { label: 'Maintenance Expense' },
  occupantName: { label: 'Occupant Name' },
  occupantType: { label: 'Occupant Type' },
  ownerName: { label: 'Owner Name' },
  subdivision: { label: 'Subdivision' },
};

const OfficeFieldMap: FieldMap<MlsListingOfficeFragment> = {
  name: { label: 'Office Name' },
  servingName: { label: 'Serving Name' },
  brokerid: { label: 'Broker ID' },
};

const OfficeContactFieldMap: FieldMap<MlsListingContactFragment> = {
  email: { label: 'Office Email' },
  office: { label: 'Office Phone' },
  cell: { label: 'Office Cell' },
};

export { OfficeContactFieldMap, OfficeFieldMap, PropertyFieldMap };
